/**
 * Parse a comma-separated list of integers from an HTML attribute value.
 * Whitespace is trimmed, empty entries and non-numeric values are dropped.
 */
export function parseCsvNumbers(value: string | null | undefined): number[] {
  if (!value) return [];
  return value
    .split(',')
    .map((segment): string => segment.trim())
    .filter((segment): boolean => segment.length > 0)
    .map((segment): number => Number.parseInt(segment, 10))
    .filter((parsed): boolean => Number.isFinite(parsed));
}

export function parseBool(value: string | null | undefined, defaultValue = false): boolean {
  if (value === null || value === undefined) return defaultValue;
  const normalized = value.toLowerCase().trim();
  if (normalized === '' || normalized === 'true' || normalized === '1' || normalized === 'yes') return true;
  if (normalized === 'false' || normalized === '0' || normalized === 'no') return false;
  return defaultValue;
}

export function parseNumber(value: string | null | undefined, defaultValue = 0): number {
  if (value === null || value === undefined || value === '') return defaultValue;
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : defaultValue;
}

export function parseEnum<T extends string>(
  value: string | null | undefined,
  allowed: readonly T[],
  defaultValue: T,
): T {
  if (!value) return defaultValue;
  return (allowed as readonly string[]).includes(value) ? (value as T) : defaultValue;
}
